import { Col } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import ChatList from './ChatList';
import ChatScreen from './ChatScreen';

const Wrapper = styled.div`
  border-left: 1px solid ${theme.GREY_20};
  border-right: 1px solid ${theme.GREY_20};
  width: ${(props) => (props.isMobile ? '100vw' : '936px')};
  height: 100%;
  display: flex;
  flex-direction: row;
  z-index: 1;
`;

const Messages = (props) => {
  const [selectedChat, setSelectedChat] = useState(null),
    [filters, setFilters] = useState({ showHidden: false, showOnlyFavorites: false }),
    user = useSelector((state) => state.user),
    chats = useSelector((state) => state.chats),
    { isMobile } = useSelector((state) => state.appState),
    [filteredChats, setFilteredChats] = useState(chats),
    dispatch = useDispatch(),
    { userId } = useParams(),
    { showOnlyFavorites, showHidden } = filters;

  useEffect(() => {
    getChats();
  }, []);

  useEffect(() => {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: { hideBottomNav: !!selectedChat }
    });
  }, [selectedChat]);

  useEffect(() => {
    const newChats = chats
      .filter((x) => {
        const chatSettings = x.users?.find((x) => (x.user._id || x.user) === user._id);
        if (!chatSettings) return false;

        const { hidden, favorite, deletedDate } = chatSettings,
          isDeleted = new Date(deletedDate) > new Date(x.updatedAt);

        if ((hidden && !showHidden) || (!x.group && !x.lastMessage) || isDeleted) return false;

        if (showOnlyFavorites) return favorite;

        return true;
      })
      .sort((a, b) => {
        const chatSettingsFirst = a.users?.find((x) => (x.user._id || x.user) === user._id),
          chatSettingsSecond = b.users?.find((x) => (x.user._id || x.user) === user._id);

        if (!chatSettingsFirst && !chatSettingsSecond) return false;

        if (chatSettingsFirst.favorite === chatSettingsSecond.favorite) {
          return b.updatedAt - a.updatedAt;
        }

        return chatSettingsSecond.favorite;
      });

    setFilteredChats(newChats.length ? newChats : []);
  }, [chats, filters]);

  function updateFilters(key, value) {
    setFilters({
      ...filters,
      [key]: value
    });
  }

  async function getChats() {
    const res = await Api.get('/chats/getChats');
    if (!res) return;

    dispatch({
      type: 'SET_CHATS',
      payload: res
    });
  }

  return (
    <Col wid="100%" centerAll ht="calc(100vh - 73px)">
      <Wrapper isMobile={isMobile}>
        <ChatList
          data={filteredChats}
          selectedChat={selectedChat}
          setSelectedChat={setSelectedChat}
          updateFilters={updateFilters}
          filters={filters}
        />

        <ChatScreen
          data={filteredChats.find((x) => x._id === selectedChat)}
          user={userId}
          selectedChat={selectedChat}
          setSelectedChat={setSelectedChat}
        />
      </Wrapper>
    </Col>
  );
};

export default Messages;
